import {
  AnalyticsEventAttributes,
  useAnalytics,
} from '@backstage/core-plugin-api';

interface GoogleAnalyticsEvent {
  action: string;
  subject: string;
  attributes?: AnalyticsEventAttributes;
  value?: number;
}

/**
 * Hook to safely track analytics events via Backstage.
 *
 * - GA4 and GTM are handled by app-config (gtmId + measurementId)
 * - User identity is resolved automatically via identity: required in config
 * - All custom attributes are forwarded via allowedAttributes: ['*']
 */
const useGoogleAnalytics = () => {
  const analytics = useAnalytics();

  const sendEvent = ({
    action,
    subject,
    attributes,
    value,
  }: GoogleAnalyticsEvent): void => {
    // Coerce to string to guard against numbers/undefined passed at runtime
    const safeAction = String(action ?? '').trim();
    const safeSubject = String(subject ?? '').trim();

    if (!safeAction || !safeSubject) {
      return;
    }

    try {
      analytics?.captureEvent(safeAction, safeSubject, {
        attributes,
        value,
      });
    } catch {
      // Never let analytics failures interrupt user interactions
      return;
    }
  };

  return { sendEvent };
};

export default useGoogleAnalytics;
